var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{attrs:{"width":`${_vm.width}vw`,"max-height":`${_vm.height}vh`,"src":_vm.src,"position":_vm.position,"alt":"picture of hotel"},on:{"load":function($event){return _vm.loaded($event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }